import { createFileRoute } from "@tanstack/react-router";
import { ShutdownPage, shutdownHead } from "@/pages/ShutdownPage";

export const Route = createFileRoute("/en/shutdown-planning")({
  head: () => shutdownHead("en"),
  component: () => <ShutdownPage locale="en" />,
});
